"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compose = void 0;
const compose = (compCompose, propsConfig) => {
  return Component => propsConfig(compCompose(Component));
};
exports.compose = compose;